var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReworkChartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86362 3.97863C5.65554 2.50029 8.37304 1 12 1C18.11 1 23 5.927 23 12C23 12.5523 22.5523 13 22 13C21.4477 13 21 12.5523 21 12C21 7.0273 17.0011 3 12 3C8.9603 3 6.67779 4.24971 5.13638 5.52137C4.7316 5.85532 4.3799 6.18935 4.08161 6.5H5.5C6.05228 6.5 6.5 6.94772 6.5 7.5C6.5 8.05228 6.05228 8.5 5.5 8.5H2C1.44772 8.5 1 8.05228 1 7.5V4C1 3.44772 1.44772 3 2 3C2.55228 3 3 3.44772 3 4V4.75186C3.2601 4.49945 3.54794 4.23906 3.86362 3.97863ZM2.85479 8.01898L2.854 8.02028L2.85445 8.01953L2.85479 8.01898ZM2 11C2.55228 11 3 11.4477 3 12C3 16.9706 7.02944 21 12 21C14.4204 21 16.4433 19.7928 17.9098 18.4999C18.2964 18.159 18.6381 17.8175 18.9313 17.5H17.5C16.9477 17.5 16.5 17.0523 16.5 16.5C16.5 15.9477 16.9477 15.5 17.5 15.5H21C21.5523 15.5 22 15.9477 22 16.5V20C22 20.5523 21.5523 21 21 21C20.4477 21 20 20.5523 20 20V19.2756C19.7652 19.5125 19.5091 19.7562 19.2324 20.0001C17.5796 21.4572 15.1024 23 12 23C5.92487 23 1 18.0751 1 12C1 11.4477 1.44772 11 2 11Z",
    fill: "#0A0E15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReworkChartIcon);
export default __webpack_public_path__ + "static/media/ReworkChartIcon.a51e149cf5a178d335a836b932bd914b.svg";
export { ForwardRef as ReactComponent };